<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>
<section class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="form-wrapper">
          <div class="email-icon">
            <img src="/assets/images/inbox-icon.svg" alt="check email" />
          </div>

          <div class="form-wrapper__header">
            <h2 data-translation-key="buyer_verify_mail_email_verification">
              {{ "buyer_verify_mail.email_verification" | translate }}
            </h2>
          </div>

          <div class="verification-info">
            <p>
              <span data-translation-key="buyer_verify_mail_sent_email_to">{{
                "buyer_verify_mail.sent_email_to" | translate
              }}</span>
              <span class="user-email">{{ email }}</span>
              <span
                data-translation-key="buyer_verify_mail_to_confirm_the_validity_of_the_email_address"
                >{{
                "buyer_verify_mail.to_confirm_the_validity_of_the_email_address"
                | translate
                }}</span
                >
              </p>
              <div class="note-container">
                <p data-translation-key="buyer_verify_mail_verify_note">
                  {{ "buyer_verify_mail.verify_note" | translate }}
                </p>
              </div>
            </div>

            <div class="form-buttons">
              <button
                type="button"
                class="btn btn-primary"
                [disabled]="countdownActive || isResending"
                (click)="resendCode()"
              [attr.data-translation-key]="
                isResending
                  ? 'forget_password_sending'
                  : 'buyer_verify_mail_resend_verification_email_2'
              "
                >
                @if (isResending) {
                  <span class="spinner"></span>
                }
                {{
                isResending
                ? ("forget_password.sending" | translate)
                : ("buyer_verify_mail.resend_verification_email_2"
                | translate)
                }}
              </button>

              @if (countdownActive) {
                <div class="countdown-timer">
                  <span
                    data-translation-key="buyer_verify_mail_resend_mail_message"
                    >
                    {{ "buyer_verify_mail.resend_mail_message" | translate }}
                  </span>
                  {{ countdown }}
                  <span data-translation-key="buyer_verify_mail_resend_seconds">
                    {{ "buyer_verify_mail.resend_seconds" | translate }}
                  </span>
                </div>
              }

              @if (showSuccess) {
                <div
                  class="success-message"
                  data-translation-key="buyer_verify_mail_resend_verification_email"
                  >
                  <i class="bi bi-check-circle-fill"></i>
                  {{ "buyer_verify_mail.resend_verification_email" | translate }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
